import { Injectable } from '@angular/core';
import {GroupSetting} from '../models/group-setting';
import {AllEventsSetting} from '../models/all-events-setting';
import {Observable, Subject} from 'rxjs/Rx';
import {BackendService} from './backend.service';

@Injectable()
export class GroupService {

  data: GroupSetting[] = [];

  constructor(private http: BackendService) { }

  groups(): GroupSetting[] {
    return this.data;
  }

  getAllGroups(reload = false): Observable<GroupSetting[]> {
    if (!reload && this.data.length) {
      return Observable.create(observe => {
        observe.next(this.data);
        observe.complete();
      });
    }
    return Observable.create((subscriber) => {
      this.http.get('/api/data/group/getAllGroups').subscribe((res) => {
        const obj = Object.assign(new AllEventsSetting(), res);
        this.data = obj.data;
        subscriber.next(this.data);
        subscriber.complete();
      }, (error) => {
        subscriber.error(error);
      });
    });
  }

  postAddGroup(group: GroupSetting): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/group/addGroup`, JSON.stringify(group))
        .subscribe((res) => {
          observe.next(res);
          observe.complete();
        }, error => {
          observe.error(error);
        });
    });
  }

  deleteGroup(groupId: number): Observable<any> {
    return Observable.create((observe) => {
      this.http.delete(`/api/data/group/deleteGroup/${groupId}`).subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  putUpdateGroup(group: GroupSetting): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/group/updateGroup/${group.id}`, JSON.stringify(group))
        .subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/group.service.ts